import { elementController } from '@public-pages/runtime-core';

elementController('issuers', ({ queryAll }) => {
  let activeIndex: number = 0;

  const issuersList = queryAll('.issuers__card');
  const contentList = queryAll('.issuers__content');

  issuersList?.[0].setAttribute('data-active', '');
  contentList?.[0].setAttribute('data-active', '');

  issuersList.forEach((issuer, index) => issuer.addEventListener('click', () => handleIssuerClick(index)));

  function closeIssuer(index: number) {
    const issuerElement = issuersList[index] as HTMLElement;
    const contentElement = contentList[index] as HTMLElement;

    issuerElement.removeAttribute('data-active');
    contentElement.removeAttribute('data-active');
  }

  function handleIssuerClick(index: number) {
    if (activeIndex !== index) {
      closeIssuer(activeIndex);
      activeIndex = index;

      const issuerElement = issuersList[index] as HTMLElement;
      const contentElement = contentList[index] as HTMLElement;

      issuerElement.setAttribute('data-active', '');
      contentElement.setAttribute('data-active', '');
    }
  }
});
